import React from 'react';
import { format } from 'date-fns'
import { If, Else, Then, Switch, Case, Default } from 'react-if'
import { Card, Button, Form, Input } from 'reactstrap';
import { Empty } from 'antd';

import { FaSearch, FaClipboardCheck, FaRegEdit, FaUndoAlt } from "react-icons/fa";
import Pagination from "react-js-pagination";
import axios from 'axios';
// import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import Select from 'react-select';

import LeaveDetailApprove from '../../components/Modal/LeaveDetailApprove';
import AllowSelectedApprove from '../../components/Modal/AllowSelectedApprove'
import ErrorSwal from '../../components/SwalError'

import { FindOne, LeaveTypeAPI } from '../../components/functions/LeaveRequestPage'
import { ApproveLists, ApproveSearchLists } from '../../components/functions/ApprovePage'
import { getEmployeeAPI } from '../../components/functions/Employee'



const Index = () => {

    const pageSize = 5
    const { t } = useTranslation()
    const currentLanguageCode = cookies.get('i18next') || 'en'
    const cancelToken = React.useRef(null)
    const [error, setError] = React.useState(null)
    const [result, setResult] = React.useState([])
    const [Approvals, setApprovals] = React.useState([])
    const [checkedState, setCheckedState] = React.useState([])
    const [isModalVisible, setIsModalVisible] = React.useState(false)
    const [isModalVisible2, setIsModalVisible2] = React.useState(false)
    const [isDesktopSize, setIsDeskTopSize] = React.useState(false)
    const [empOptions, setEmpOptions] = React.useState([])
    const [leaveEnOpts, setLeaveEnOpts] = React.useState([])
    const [leaveThOpts, setLeaveThOpts] = React.useState([])
    const [leaveJpOpts, setLeaveJpOpts] = React.useState([])
    const StatusOpts = [
        { label: `${t("t_st_drf")}`, value: '-3' },
        { label: `${t("t_st_ped")}`, value: '0' },
        { label: `${t("t_st_app")}`, value: '1' },
        { label: `${t("t_st_can")}`, value: '-1' },
        { label: `${t("t_st_rej")}`, value: '-2' },

    ];
    const empRef = React.useRef();
    const statusRef = React.useRef();
    const typeRef = React.useRef();

    const [search, setSearch] = React.useState({})
    const [values, setValues] = React.useState({
        EmpNo: '',
        LeaveID: '',
        LeaveType: '',
        Reason: '',
        Status: '',
        Amount: '',
        Time: '',
        ToDate: '',
        EndDate: '',
        ToTime: '',
        EndTime: '',
        fileName: '',
        ApproveRemark: '',
        ApprovalStatus: '',
        leaveTypes: [],
    })

    // pagination
    const [page, setPage] = React.useState(1)
    const [total, setTotal] = React.useState(0)

    const getData = async (page) => {
        try {

            const res_emp = await getEmployeeAPI()
            const res_type = await LeaveTypeAPI()
            const resp = await ApproveLists(page, pageSize)
            setResult(resp.data.PaginationLists.tutorials)
            setTotal(resp.data.PaginationLists.totalItems)
            setEmpOptions(res_emp.data.empOpts)
            setLeaveEnOpts(res_type.data.leaveEnOpts)
            setLeaveThOpts(res_type.data.leaveThOpts)
            setLeaveJpOpts(res_type.data.leaveJpOpts)


        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }

    }

    React.useEffect(() => {
        cancelToken.current = axios.CancelToken.source();

        getData(page);
        return () => {

            cancelToken.current.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page])

    const handlePageChange = (pageNumber) => {
        setCheckedState([])
        setPage(pageNumber)
    }
    // Set Search Combobox
    const handleChange = (e) => {
        setSearch({
            ...search,
            [e.target.name]: e.target.value
        })
    }
    // Set Search Employee  
    const handleChangeEmp = (selectedOption) => {
        setSearch({
            ...search,
            'searchEmpNo': selectedOption.value
        })

    }
    // Set Search Leave Type  
    const handleChangeLeaveType = (selectedOption) => {
        setSearch({
            ...search,
            'searchLeaveType': selectedOption.value
        })
    }
    // Set Search Status   
    const handleChangeStatus = (selectedOption) => {
        setSearch({
            ...search,
            'searchStatus': selectedOption.value
        })
    }

    // Search Data
    const handleClickSubmit = async (e) => {
        e.preventDefault()

        await ApproveSearchLists(search, page, pageSize)
            .then((response) => {
                setResult(response.data.PaginationLists.tutorials)
                setTotal(response.data.PaginationLists.totalItems)
            })
            .catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
    }

    // Reset-Search
    const handleReset = () => {

        document.getElementById("search-form").reset();
        empRef.current.setValue('');
        typeRef.current.setValue('');
        statusRef.current.setValue('');
        getData(page);
    }

    const checkRenderButton = (leaveApproval) => {
        let found = leaveApproval.find(function (item) {
            return item.APP_NO === JSON.parse(localStorage.getItem("profile")).EMP_NO
        });
        return found.APP_STATUS
    }

    const showModal = async (Leave) => {

        await FindOne(Leave.LEAVE_NO)
            .then((response) => {
                setApprovals(response.data.leave)

                setValues({
                    ...values,
                    EmpNo: response.data.leave.EMP_NO,
                    LeaveID: response.data.leave.LEAVE_NO,
                    LeaveType: response.data.leave.TYPECD,
                    Reason: response.data.leave.REASON,
                    Status: response.data.leave.STATUS,
                    Amount: response.data.leave.DAYS_QTY,
                    Time: response.data.leave.MIN_QTY,
                    ToDate: (format(new Date(response.data.leave.BEGIN_DT), 'dd/MM/yyyy')),
                    EndDate: (format(new Date(response.data.leave.END_DT), 'dd/MM/yyyy')),
                    ToTime: response.data.leave.BEGIN_TIME,
                    EndTime: response.data.leave.END_TIME,
                    fileName: response.data.leave.PATH_FILE,
                    ApproveRemark: response.data.leave.SIGN_REASON,
                    ApprovalStatus: checkRenderButton(response.data.leave.leaveApproval),
                    leaveTypes: response.data.leave.leaveTypes

                })

                setIsModalVisible(true);
                // ----------- resize screen -----------------
                if (window.innerWidth < 400) {
                    setIsDeskTopSize(true)
                } else {
                    setIsDeskTopSize(false)
                }
                // ----------- resize screen -----------------
            })
            .catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })


    }

    const showModal2 = () => {
        setIsModalVisible2(true);
    }

    const handleOnChange = (LeaveID) => {

        const findIdx = checkedState.indexOf(LeaveID);
        if (findIdx > -1) {
            checkedState.splice(findIdx, 1);
        } else {
            checkedState.push(LeaveID);
        }
    }

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null)
    }

    return (
        <>
            <div className="container">
                {/* Search Component */}
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <Card>
                            <div className="card-content">
                                <div className="card-body">
                                    <Form className="row g-3" onSubmit={handleClickSubmit} id="search-form">
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label  className="col-sm-3 col-form-label col-form-label-sm"> {t("t_date_from")} :</label>
                                                <div className="col-sm-8">
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        name="searchFrom"
                                                        id="searchFrom"
                                                        onChange={handleChange}
                                                        placeholder="MM/DD/YYYY"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label  className="col-sm-3 col-form-label col-form-label-sm"> {t("t_date_to")} :</label>
                                                <div className="col-sm-8">
                                                    <input
                                                        className="form-control"
                                                        type="date"
                                                        name="searchTo"
                                                        id="searchTo"
                                                        placeholder="To"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label  className="col-sm-3 col-form-label col-form-label-sm"> {t("t_emp")} :</label>
                                                <div className="col-sm-8">
                                                    <Select placeholder={t("t_st_all")} name="searchEmpNo" ref={empRef} options={empOptions} onChange={handleChangeEmp} styles={{ singleValue: (base) => ({ ...base, color: '#607080' }) }} />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label  className="col-sm-3 col-form-label col-form-label-sm"> {t("t_leave_type")} :</label>
                                                <div className="col-sm-8">
                                                    <Switch>
                                                        <Case condition={currentLanguageCode === 'en'}>
                                                            <Select placeholder={t("t_st_all")} name="searchLeaveType" ref={typeRef} options={leaveEnOpts} onChange={handleChangeLeaveType} styles={{ singleValue: (base) => ({ ...base, color: '#607080' }) }} />
                                                        </Case>
                                                        <Case condition={currentLanguageCode === 'th'}>
                                                            <Select placeholder={t("t_st_all")} name="searchLeaveType" ref={typeRef} options={leaveThOpts} onChange={handleChangeLeaveType} styles={{ singleValue: (base) => ({ ...base, color: '#607080' }) }} />
                                                        </Case>
                                                        <Case condition={currentLanguageCode === 'jp'}>
                                                            <Select placeholder={t("t_st_all")} name="searchLeaveType" ref={typeRef} options={leaveJpOpts} onChange={handleChangeLeaveType} styles={{ singleValue: (base) => ({ ...base, color: '#607080' }) }} />
                                                        </Case>
                                                    </Switch>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label  className="col-sm-3 col-form-label col-form-label-sm"> {t("t_status")} :</label>
                                                <div className="col-sm-8">
                                                    <Select placeholder={t("t_st_all")} name="searchStatus" ref={statusRef} options={StatusOpts} onChange={handleChangeStatus} styles={{ singleValue: (base) => ({ ...base, color: '#607080' }) }} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label  className="col-sm-3 col-form-label col-form-label-sm"> {t("t_keyword")}  :</label>
                                                <div className="col-sm-8">
                                                    <input className="form-control"
                                                        type="search"
                                                        name="searchText"
                                                        id="searchText"
                                                        placeholder={t("t_keyword_holder")}
                                                        onChange={handleChange}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="gap-2 d-grid d-md-flex justify-content-md-center">
                                            <Button color="primary" type="submit">
                                                <FaSearch /> {t("b_search")}
                                            </Button>
                                            <Button color="danger" type="reset" onClick={handleReset}>
                                                <FaUndoAlt /> {t("b_reset")}
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
                {/* Search Component */}

                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        {/* <ApproveList result={search} /> */}
                        {/* <ApproveList data={data} search={search}/> */}
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <h4 className="card-title">  {t("t_approve_list")} </h4>
                                    </div>
                                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                        <div className="gap-2 d-grid d-md-flex justify-content-md-end">
                                            <Button color="success"
                                                onClick={async () => { showModal2() }} >
                                                <FaClipboardCheck /> {t("t_approve_reject")}
                                            </Button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    {result.length > 0 ? (
                                        <table className="table mb-0 table-lg">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: '5%' }}>#</th>
                                                    <th scope="col" style={{ width: '5%' }}> {t("t_status")} </th>
                                                    <th scope="col" style={{ width: '15%' }}> {t("t_name")} </th>
                                                    <th scope="col" style={{ width: '35%' }}> {t("t_leave_dtl")} </th>
                                                    <th scope="col" style={{ width: '5%' }}> {t("t_amount")} </th>
                                                    <th scope="col" style={{ width: '25%' }}> {t("t_reason")} </th>
                                                    <th scope="col" style={{ width: '10%' }}> {t("t_request")} </th>
                                                    <th scope="col" style={{ width: '5%' }}> {t("t_action")} </th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ fontSize: '0.9rem' }}>
                                                {
                                                    result.map((list, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <div className="checkbox">
                                                                        <If condition={list.leaveApproval[0].APP_STATUS === "0"}>
                                                                            <Then>
                                                                                <Input type="checkbox"
                                                                                    id={list.LEAVE_NO}
                                                                                    key={list.LEAVE_NO}
                                                                                    name={list.LEAVE_NO}
                                                                                    value={list.LEAVE_NO}
                                                                                    onChange={() => handleOnChange(list)}
                                                                                    className="form-check-input"
                                                                                />
                                                                            </Then>
                                                                            <Else>
                                                                                <Input type="checkbox"
                                                                                    id={list.LEAVE_NO}
                                                                                    name={list.LEAVE_NO}
                                                                                    value={list.LEAVE_NO}
                                                                                    disabled
                                                                                    onChange={() => handleOnChange(list)}
                                                                                    className="form-check-input"
                                                                                />
                                                                            </Else>
                                                                        </If>
                                                                    </div>
                                                                </td>
                                                                <td className="text-bold-500">
                                                                    {
                                                                        <Switch>
                                                                            <Case condition={parseInt(list.leaveApproval[0].APP_STATUS) === 0}>
                                                                                <span className="badge bg-warning" style={{ color: '#fff' }}>P</span>
                                                                            </Case>
                                                                            <Case condition={parseInt(list.leaveApproval[0].APP_STATUS) >= 1}>
                                                                                <span className="badge bg-success" style={{ color: '#fff' }}>A</span>
                                                                            </Case>
                                                                            <Case condition={parseInt(list.leaveApproval[0].APP_STATUS) < 0}>
                                                                                <span className="badge bg-danger" style={{ color: '#fff' }}>C</span>
                                                                            </Case>
                                                                            <Default>
                                                                                <span className="badge bg-danger" style={{ color: '#fff' }}>R</span>
                                                                            </Default>
                                                                        </Switch>
                                                                    }
                                                                </td>
                                                                <td className="text-bold-500">
                                                                    {list.employees.FULL_NAME}
                                                                </td>
                                                                <td className="text-bold-500">
                                                                    {
                                                                        list.ALL_DAY_F === "1" ?
                                                                            `${format(new Date(list.BEGIN_DT), 'dd/MM/yyyy')} - ${format(new Date(list.END_DT), 'dd/MM/yyyy')}` : `${format(new Date(list.BEGIN_DT), 'dd/MM/yyyy')} ${list.BEGIN_TIME} - ${list.END_TIME}`
                                                                    }
                                                                </td>
                                                                <td className="text-bold-500">
                                                                    {
                                                                        list.ALL_DAY_F === "1" ? `${list.DAYS_QTY} day` : list.MIN_QTY
                                                                    }
                                                                </td>
                                                                <td className="text-bold-500">{list.REASON}</td>

                                                                <td className="text-bold-500">{format(new Date(list.RGSTD), 'dd/MM/yyyy')}</td>
                                                                <td>
                                                                    <Button color="primary"
                                                                        onClick={async () => { showModal(list) }}
                                                                    // onClick={async () => { setIsModalVisible(true) }} 
                                                                    >

                                                                        <FaRegEdit />
                                                                    </Button>

                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>
                                        </table>
                                    ) :
                                     <Empty />
                                    }
                                </div>

                            </div>
                            <div className="d-flex justify-content-center">
                                <div className="mt-2">
                                    {result.length > 0 ? (
                                        <Pagination
                                            activePage={page}
                                            itemsCountPerPage={pageSize}
                                            totalItemsCount={total}
                                            pageRangeDisplayed={5}
                                            onChange={handlePageChange}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            hideNavigation={true}
                                        />
                                    ) :
                                        <></>
                                    }
                                </div>
                            </div>
                        </div>

                        {/* Leave Details Modal */}
                        {isModalVisible ? <LeaveDetailApprove isOpen={isModalVisible} isModalVisible={setIsModalVisible} values={values} Approvals={Approvals}  isDesktopSize={isDesktopSize} /> : null}
                        {/* Leave Details Modal */}

                        {/*  Allow Selected Approve Modal*/}
                        {isModalVisible2 ? <AllowSelectedApprove isOpen={isModalVisible2} isModalVisible={setIsModalVisible2} checkedState={checkedState} /> : null}
                        {/*  Allow Selected Approve Modal*/}

                    </div>
                </div>
            </div>

        </>
    )
}

export default Index
